module.exports = __webpack_public_path__ + "img/alif-tips.4a33b29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/svgs/alif-tips.svg
// module id = 1204
// module chunks = 1